import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/account.css";
import { useUser } from "../context/UserContext";
import AccountLayout from "../layouts/AccountLayout";
import CURRENCY from "./../assets/images/currency_icon.png";
import { adminRoles, userRankText } from "../utils";
import { useState } from "react";
import ToastNotification, { showToast, showTopCenterToast } from "../components/toasts/ToastNotification";
import { HashLoader } from "react-spinners";
import { getUser } from "../api/user.api";

const AccountPage = () => {
  const { user, setUser } = useUser();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      setLoading(true);

      const res = await getUser(user._id);

      if (res?.success) {
        setUser(res.data.user);
      }
    } catch (error) {
      showTopCenterToast(error.message, "error");
    }
    finally {
      setLoading(false);
    }
  }

  const handleLogout = () => {
    navigate("/logout");
  };
  return (
    <AccountLayout title="Tài khoản của tôi">
      <div className="account-information-container">
        <ToastNotification/>
        {loading ?
          <div className="loader-container">
            <HashLoader color="#0d79e2" size={30} />
          </div>
          :
          <>
            <section className="account-grid account-card">
              <div className="profile-info">
                <img
                  className="profile-avatar"
                  src={
                    user?.profileImg ||
                    "https://cdn1.iconfinder.com/data/icons/user-pictures/101/malecostume-512.png"
                  }
                  alt="User Avatar"
                ></img>
                <div>
                  <h2>{user?.username || "User"}</h2>
                  <span className="user-rank">{userRankText(user?.rank)}</span>
                </div>
                <button onClick={() => navigate('/account/change-information')} className="update-btn">Cập nhật tài khoản</button>
                {(
                  adminRoles.includes(user?.role)
                ) && (
                    <button
                      onClick={() => navigate("/super-admin/dashboard")}
                      className="update-btn"
                    >
                      Trang Admin
                    </button>
                  )}
              </div>
            </section>

            <section className="account-grid">
              <div className="account-card balance-card">
                <p>Số dư</p>
                <div className="user-balance-container">
                  <img className="currency" src={CURRENCY} alt="currency"></img>
                  <h3 className="account-user-balance">
                    {user?.balance.toLocaleString() || 0}đ
                  </h3>
                </div>
                <div className="button-group">
                  <button onClick={() => navigate("/payment")}>
                    Nạp tiền
                  </button>
                </div>
              </div>

              {/* <div className="account-card storage-card">
            <p>Kho hàng</p>
            <div className="storage-stats">
              <span>0 Chờ xử lý</span>
              <span>0 Đang xử lý</span>
              <span>0 Hoàn thành</span>
              <span>0 Bị hủy</span>
            </div>
          </div> */}

              <div className="account-card password-card">
                <p>Đổi mật khẩu</p>
                <input type="password" value="********" disabled />
                <div className="button-group">
                  <button onClick={() => navigate('/account/change-password')}>Đổi mật khẩu</button>
                </div>
              </div>
              <div className="account-card password-card">
                <p>Đăng xuất</p>
                <div className="button-group">
                  <button className="logout-button" onClick={handleLogout}>
                    Đăng xuất
                  </button>
                </div>
              </div>
            </section>
          </>
        }

      </div>
    </AccountLayout>
  );
};

export default AccountPage;
